import { Controller, useForm } from "react-hook-form";
import PersonalDetails from "./RegistrtionDetails/PersonalDetails";
import AddressDetails from "./RegistrtionDetails/AddressDetails";
import {
  Avatar,
  Badge,
  BadgeProps,
  Button,
  CircularProgress,
  Paper,
  styled,
  Typography,
} from "@mui/material";
import EmergencyContact from "./RegistrtionDetails/EmergencyContact";
import { useQuery } from "react-query";
import {
  useEffect,
  useState,
  Dispatch,
  SetStateAction,
  createContext,
  useRef,
} from "react";
import usePopup from "../../../hooks/usePopup";
// import { addressDetailsFields, personalDetailsFields } from "./fieldData";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
// import axios from "axios";
// import moment from "moment";
import { getCountry } from "../v1/registrationServices";
import {
  EmergencyContactFormType,
  extractFormData,
  // extractPatientData,
  initialRegistrationData,
  PatientRegistrationFormType,
} from "./type/RegistrationModel";
// import { calculateAge } from "../../../utilis/methods/dateMethods";
import useGetByPatientMasterId from "./hooks/useGetByPatientMasterId";
import {
  CountryType,
  PatientRegistrationDataType,
  SaveResponseType,
} from "./type/RegistrationDataType";
import useSaveRegistration from "./hooks/useSaveRegistration";
import moduleRoutes from "../../../routes/moduleRouteList";
import patientCareRouteList from "../../routeList";
import {
  getReceptionPath,
  RECEPTION_TABS,
} from "@utilifiles/methods/navigation/receptionNavigation";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CameraComponent, { OnCaptureParamsType } from "./CameraComponent";
import HideImageIcon from "@mui/icons-material/HideImage";
import ReadEid from "./ReadEid";
import { ReaderDataType } from "./type/ReaderComponentTypes";
import { base64ToFile } from "@utilifiles/methods/fileOperations";
// import * as eidatoolkit from '../../../lib/eidatoolkit';
const StyledBadge = styled(Badge)<BadgeProps>(() => ({
  "& .MuiBadge-badge": {
    right: 4,
    bottom: 4,
  },
}));
export const RegistrationContext = createContext<{
  emergencyContact: EmergencyContactFormType[];
  setEmergencyContact: Dispatch<SetStateAction<EmergencyContactFormType[]>>;
  fullReset:boolean;
  setFullReset: Dispatch<SetStateAction<boolean>>;
}>({
  emergencyContact: [],
  setEmergencyContact: () => {},
  fullReset:false,
  setFullReset: () => {},
});
const base = (window as any)._env_?.BASE_URL;
function RegistrationForm() {
  const inputFileRef = useRef<HTMLInputElement | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [emergencyContact, setEmergencyContact] = useState<
    EmergencyContactFormType[]
  >([]);
  const [saveLoading, setSaveLoading] = useState<boolean>(false);
  const [patientImage, setPatientImage] = useState<string>("");
  const [viewImage, setViewImage] = useState<boolean>(false);
  const [fullReset,setFullReset] = useState<boolean>(false)
  const [searchParams] = useSearchParams();
  const { patientid } = useParams();
  const bookingId = searchParams.get("bookingId");
  const formControls = useForm<PatientRegistrationFormType>();
  const { handleSubmit, reset, control, setValue, getValues } = formControls;
  const { CustomModal } = usePopup();
  // const [cardDataLoading, setCardDataLoading] = useState<boolean>(false);

  const { data: countries } = useQuery(["getCountry"], getCountry, {
    refetchOnWindowFocus: false,
  });

  const handleSetData = (data: PatientRegistrationDataType | null) => {
    if (data != null) {
      let formatedData = extractFormData(data);
      if (bookingId) {
        formatedData = {
          ...formatedData,
          country: initialRegistrationData.country,
          state: initialRegistrationData.state,
          place: initialRegistrationData.place,
          isVip: initialRegistrationData.isVip,
        };
      }
      reset(formatedData);
      setEmergencyContact(formatedData.emergencyContact || []);
      setPatientImage(data?.image || "");
    }
  };

  const {
    mutate: getDetails,
    isLoading: detailsLoading,
    data: patientData,
    reset: resetMutation,
  } = useGetByPatientMasterId(handleSetData);

  const goToEncounter = (data: SaveResponseType) => {
    bookingId
      ? navigate(
          `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientEnounter}/${data.patientId}?bookingId=${bookingId}`
        )
      : !Boolean(patientid) &&
        navigate(
          `${base}${moduleRoutes.mainRoute}/${moduleRoutes.patientCare}/${patientCareRouteList.patientEnounter}/${data.patientId}`
        );
  };

  const resetForm = () => {
    setFullReset(true)
    setPatientImage("");
    reset(initialRegistrationData);
    setEmergencyContact([]);
  };

  const navigateToReceptionRegistrations = () => {
    navigate(getReceptionPath(RECEPTION_TABS.registrations));
  };

  const saveSuccess = (data: SaveResponseType) => {
    resetForm();
    if (Boolean(bookingId) || Boolean(patientid)) {
      if (Boolean(bookingId) && Boolean(patientid)) {
        goToEncounter(data);
      } else if (Boolean(patientid)) {
        location.state?.Registration
          ? navigateToReceptionRegistrations()
          : navigate(-1);
      }
    } else {
      goToEncounter(data);
    }
  };

  const save = useSaveRegistration(setSaveLoading, saveSuccess);
  
  const onSubmit = (value: PatientRegistrationFormType) => {
    const destination = "Registered";
    save(
      value,
      patientData?.response as PatientRegistrationDataType,
      emergencyContact,
      Boolean(bookingId) ? Number(bookingId) : null,
      destination,
    );
  };

  const genderObj = {
    M: "Male",
    F: "Female",
  };

  const handleData = (data: ReaderDataType) => {
    const readerData: {
      firstName: string;
      middleName: string;
      lastName: string;
      id: string;
      email: string;
      mobileNo: string;
      nationality: CountryType | null;
      countryCode: CountryType | null;
      gender: "Male" | "Female" | null ;
      dob: string;
    } = {
      firstName: "",
      middleName: "",
      lastName: "",
      id: "",
      email: "",
      mobileNo: "",
      nationality: null,
      countryCode: null,
      gender:null,
      dob: "",
    };
    if (data?.nationality && countries?.response) {
      readerData.nationality =
        countries?.response.find(
          (c) => c.countryName.toLowerCase() == data?.nationality?.toLowerCase()
        ) || null;
    }
    if (data?.countryCode && countries?.response) {
      readerData.countryCode =
        countries?.response.find((c) => c.countryCode == data?.countryCode) ||
        null;
    }
    readerData.gender = (genderObj[`${data?.gender}`]) as
      | "Male"
      | "Female"
     
    readerData.firstName = data?.firstName || "";
    readerData.middleName = data?.middleName || "";
    readerData.lastName = data?.lastName || "";
    readerData.id = data?.emiratesId || "";
    readerData.email = data?.email || "";
    readerData.mobileNo = data?.mobileNo || "";
    readerData.dob = data?.dob || "";
    let file: File | null = null;
    if (data?.cardHolderPhoto) {
      setPatientImage(data?.cardHolderPhoto || "");
      file = base64ToFile(data?.cardHolderPhoto, data?.firstName || "");
    }
    const preData = getValues();
    reset({
      ...preData,
      ...(readerData as PatientRegistrationFormType),
      file,
    });
  };

  const goBack = () => {
    if (location.state?.Registration) {
      navigateToReceptionRegistrations();
    } else {
      navigate(-1);
    }
  };

  const handleImageCapture = (data: OnCaptureParamsType) => {
    setPatientImage(data.imageUrl);
    if (inputFileRef.current?.files) {
      setValue("file", data.file);
    }
  };

  const handleOpenPatientImage = () => {
    setViewImage(true);
  };

  useEffect(() => {
    if (bookingId || patientid) {
      getDetails({
        patientMasterId: patientid as string,
        bookingId: bookingId,
      });
    } else {
      resetForm();
      resetMutation();
      setEmergencyContact([]);
    }
  }, [bookingId, patientid]);

  return (
    <RegistrationContext.Provider
      value={{ emergencyContact, setEmergencyContact,fullReset,setFullReset }}
    >
      <CustomModal
        title="Patient image"
        open={viewImage}
        setOpen={setViewImage}
      >
        <div>
          {patientImage ? (
            <img
              alt="Patient image"
              src={patientImage}
              style={{ width: "640px", height: "480px", objectFit: "contain" }}
            />
          ) : (
            <div className="flex justify-center items-center w-[640px] h-[480px]">
              <Typography>
                No image <HideImageIcon color="warning" />
              </Typography>
            </div>
          )}
        </div>
      </CustomModal>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="file"
          defaultValue={null}
          render={({ field: { onChange, onBlur, name } }) => (
            <input
              type="file"
              name={name}
              onBlur={onBlur}
              onChange={(e) => {
                const file = e.target.files?.[0] || null;
                onChange(file);
              }}
              ref={inputFileRef} // you can forward this to another ref if needed
              className="hidden"
            />
          )}
        />

        <Paper className="p-3 mt-4">
          <div className="border-b p-2 flex justify-between items-center">
            <Typography color="primary">Registration Details</Typography>
            {/* <div className="flex gap-2"> */}
            <div className="flex flex-row justify-center items-center gap-4 ">
              {detailsLoading && (
                <Typography color="primary" fontWeight={500}>
                  Fetching Details <CircularProgress size={18} />
                </Typography>
              )}
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <CameraComponent onCapture={handleImageCapture} />
                }
              >
                <Avatar
                  onClick={handleOpenPatientImage}
                  sx={(theme) => ({
                    height: 56,
                    width: 56,
                    borderColor: theme.palette.success.main,
                    borderWidth: 1,
                    p: 0.2,
                    cursor: "pointer",
                  })}
                  alt="Image"
                  src={patientImage}
                />
              </StyledBadge>
              <ReadEid handleData={handleData}/>
              {Boolean(bookingId) ||
                (Boolean(patientid) && (
                  <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={goBack}
                    color="error"
                  >
                    back
                  </Button>
                ))}
            </div>
          </div>
          {/* </div> */}
          <div>
            <div className="grid sx:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5 px-2 drop-shadow h-fit">
              <PersonalDetails formControls={formControls} />
              <AddressDetails formControls={formControls} />
              <div className="col-span-full pt-4">
                <EmergencyContact />
              </div>
              <div className="col-span-full flex flex-row justify-between items-center">
                <div></div>

                <div className=" p-2 flex justify-end gap-2 items-center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={saveLoading}
                    endIcon={saveLoading && <CircularProgress size={20} />}
                    // onClick={handleCheckError}
                  >
                    {!Boolean(patientid) || Boolean(bookingId)
                      ? "register"
                      : "update"}
                  </Button>
                  {!Boolean(patientid) && (
                    <Button
                      type="reset"
                      onClick={resetForm}
                      variant="contained"
                      color="error"
                    >
                      reset
                    </Button>
                  )}
                  {/* <Button
                onClick={() => {
                  navigate(
                    `${base}iframe/encounter/${patientId?.id}/${patientId?.type}`
                  );
                }}
              >
                click
              </Button> */}
                </div>
              </div>
            </div>
          </div>
        </Paper>
      </form>
    </RegistrationContext.Provider>
  );
}

export default RegistrationForm;